import { INTRODUCTION_LIST } from '../index.js';
import IntroductionCard from './IntroductionCard';
export default {
  components: {
    IntroductionCard
  },
  data() {
    return {
      introductionList: INTRODUCTION_LIST
    };
  }
};